import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { FUNDING_BATCH_TRANSFER_BASE_PATH } from '../../../../../features/funding/batch-transfer/funding-batch-transfer-routing';

export const Route = createFileRoute('/_app/_clearing-core/funding/batch-transfer/_batch-transfer')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'funding-batch-transfer-list',
        label: 'Funding',
        to: FUNDING_BATCH_TRANSFER_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
